// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__11R15","calendarButtons":"ClockData_calendarButtons__2k4eo"};